module Meevo.Plugins.Employee {
  "use strict";

  /**
  * Deduction Section of Employee 
  */
  export class DeductionSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeDeduction> {
      employeeName?: string = "";
      constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
          handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
          loggingService: Meevo.Components.Logging.ILoggingService,
          dataService: Meevo.Components.BaseClasses.IDataService,
          identityService: Meevo.Components.Common.IIdentityService,
          noun: Meevo.Model.NounEnum,
          protected modalService: Components.Modal.IModalService,
          sectionSecurityKey?: string,
          _translateService?: ng.translate.ITranslateService,
           _employeeName?: string) {

          super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
          this.modalService = modalService;
      }

      onServiceDeducationChanged(): void {
          if (this.model.backupApplyServiceDeductions != this.model.applyServiceDeductions) {
              this.modalService.warning("MESSAGE_SERVICE_DEDUCTION_MODE_CHANGE", 0, false, {
                  showCancelButton: true,
                  okButtonContentKey: 'LABEL_YES',
                  cancelButtonContentKey: 'LABEL_NO',
                  cancelButtonHotKey: 'MODAL_NO_BUTTON',
                  okButtonHotKey: 'MODAL_YES_BUTTON'
              }).then((result) => {
                  if (result) {
                      this.model.applyServiceDeductions = this.model.applyServiceDeductions;
                      this.model.backupApplyServiceDeductions = this.model.applyServiceDeductions;
                              }
                 }).catch((reason) => {
                     this.model.applyServiceDeductions = this.model.backupApplyServiceDeductions;
              });
          }
      }

      /**
      * Feature 140532: the $0.00-services checkbox governs nothing in After Commission mode, so it is hidden there.
      * Written as "not After" rather than "is Before" because a blank dropdown is saved and calculated as Before.
      */
      isZeroDollarDeductionVisible(): boolean {
          return DeductionSection.isZeroDollarDeductionVisible(this.model);
      }

      static isZeroDollarDeductionVisible(model: Model.EmployeeDeduction): boolean {
          return !!model && model.applyServiceDeductions != Model.ApplyServiceDeductionsEnum.AfterCommissionIsCalculated;
      }

      /**
      * Feature 140532: same warning and Yes/No semantics as the Apply Service Deductions dropdown.
      * Yes only confirms (Save still commits); No restores the last confirmed value.
      */
      onZeroDollarDeductionChanged(): void {
          if (this.model.backupApplyDedsToZeroChargeService != this.model.applyDedsToZeroChargeService) {
              this.modalService.warning("MESSAGE_SERVICE_DEDUCTION_MODE_CHANGE", 0, false, {
                  showCancelButton: true,
                  okButtonContentKey: 'LABEL_YES',
                  cancelButtonContentKey: 'LABEL_NO',
                  cancelButtonHotKey: 'MODAL_NO_BUTTON',
                  okButtonHotKey: 'MODAL_YES_BUTTON'
              }).then((result) => {
                  if (result) {
                      this.model.backupApplyDedsToZeroChargeService = this.model.applyDedsToZeroChargeService;
                  }
              }).catch((reason) => {
                  this.model.applyDedsToZeroChargeService = this.model.backupApplyDedsToZeroChargeService;
              });
          }
      }
  }
}